import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { FlyoutService } from '../services/flyout.service';

@Directive({
  selector: '[appFlyoutAnchor]',
})
export class FlyoutAnchorDirective implements OnInit {
  private element = inject(ElementRef);
  private service = inject(FlyoutService);

  ngOnInit(): void {
    this.service.setAnchor(this.element);
  }
}
